import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useDictionaryStore } from "@/stores/dictionary";
import { useAIAssistant } from "@/contexts/AIAssistantContext";
import { useIsMobile } from "@/hooks/use-mobile";
import { DictionaryPanel } from "./DictionaryPanel";

export function DictionaryWidget() {
    const { isOpen, closeWidget } = useDictionaryStore();
    const { isOpen: isAIOpen } = useAIAssistant();
    const location = useLocation();
    const isMobile = useIsMobile();

    // Hide floating button on practice pages (rendered inside layout) and My Topics
    const isPracticePage = location.pathname.startsWith("/session/") && location.pathname.endsWith("/practice");
    const isAIPage = location.pathname === "/my-topics/ai" || location.pathname.startsWith("/my-topics/ai/");
    const isMyTopicsPage = location.pathname === "/my-topics" || location.pathname.startsWith("/my-topics/");

    if (isPracticePage || isAIPage || isMyTopicsPage) {
        return null;
    }

    if (isAIOpen) {
        return null;
    }

    if (isMobile) {
        return (
            <>
                <AnimatePresence>
                    {isOpen && (
                        <>
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                className="fixed inset-0 z-40 bg-black/50"
                                onClick={closeWidget}
                            />

                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 20 }}
                                transition={{ duration: 0.25, ease: "easeOut" }}
                                className="fixed inset-x-0 top-0 bottom-14 z-50 bg-card flex flex-col"
                            >
                                <DictionaryPanel onClose={closeWidget} isMobile />
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </>
        );
    }

    return (
        <>
            <AnimatePresence>
                {isOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className="fixed inset-0 z-40"
                            onClick={closeWidget}
                        />

                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.2, ease: "easeOut" }}
                                className="fixed z-50 bottom-3 right-3 bg-card border border-border/60 rounded-2xl shadow-[0_8px_40px_-8px_rgba(0,0,0,0.3),0_0_0_1px_rgba(0,0,0,0.05)] flex flex-col overflow-hidden w-80 max-w-[calc(100vw-2rem)] h-[500px] max-h-[65vh]"
                        >
                            <DictionaryPanel onClose={closeWidget} />
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </>
    );
}
